var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isBuiltInLibrary)?_c('network-case-library'):(_vm.isPolicyLibrary)?_c('policy-case-library'):(_vm.isPolicyTraining)?_c('policy-training-home'):(_vm.isPolicyCustom)?_c('policy-custom-cases',{ref:"policy"}):_c('case-management',{key:_vm.managementKey})
}
var staticRenderFns = []

export { render, staticRenderFns }